import { Configuration, requireDefined } from '@nutrien/ddc-orchestrator-logging-legacy';
import packageJson from '../../package.json';
import { resolveSentryConfig } from './sentryConfig';

export async function resolveLoggingConfiguration(): Promise<Configuration> {
  const sentryConfig = await resolveSentryConfig();

  return {
    application: {
      name: packageJson.name,
      platform: 'nx',
      project: 'dxp',
      version: packageJson.version,
    },
    applicationDomains: requireDefined(process.env.REACT_APP_NUTRIEN_DOMAINS).split(','),
    applicationId: requireDefined(process.env.REACT_APP_LOGGING_APPLICATION_ID),
    endPoint: requireDefined(process.env.REACT_APP_LOGGING_END_POINT),
    environment: process.env.REACT_APP_ENV || 'unknown',
    identityPoolId: requireDefined(process.env.REACT_APP_LOGGING_IDENTITY_POOL_ID),
    region: requireDefined(process.env.REACT_APP_LOGGING_REGION),
    sentryEnabled: sentryConfig.enabled,
    sentryDsn: process.env.REACT_APP_SENTRY_DSN,
    replaysSessionSampleRate: sentryConfig.replaysSessionSampleRate,
    replaysOnErrorSampleRate: sentryConfig.replaysOnErrorSampleRate,
    tracesSampleRate: sentryConfig.tracesSampleRate,
    sampleRate: sentryConfig.sampleRate,
  };
}
